














import { Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'

@Component
export default class ColumnPipeline extends Vue {
    @Prop({ required: true }) referral!: Referral
}
